import { useEffect, useRef } from 'react';

export default function Vision() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const scrollValue = window.scrollY;
            const section = sectionRef.current;
            if (section) {
                // Subtle parallax effect
                section.style.backgroundPositionY = `${(scrollValue - section.offsetTop) * 0.4}px`;
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <section
            ref={sectionRef}
            className="vision-section"
            style={{
                backgroundImage: 'url("/Image.jpeg")',
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }}
        >
            <div className="vision-overlay"></div>
            <div className="container vision-container">
                <div className="vision-content reveal">
                    <p className="vision-label">Ma Vision</p>
                    <h2 className="vision-quote">
                        "Le code est l'art de l'invisible, <br />
                        l'IA est le souffle qui lui donne vie."
                    </h2>
                    <div className="vision-divider"></div>
                    <p className="vision-text">
                        Au Service de l'élégance technique et de la performance.
                        Je conçois des écosystèmes digitaux où l'intelligence artificielle
                        rencontre le design d'exception.
                    </p>
                </div>
            </div>
        </section>
    );
}
